<div class="top-banner">
  <div class="top-banner-text">
    {{ bannerText() }}
  </div>
</div>
